<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<header><h1 class="fmtitle1" epub:type="title"><span epub:type="pagebreak" id="page_ix" title="ix">Contents</span></h1></header>
<p class="toc"><a href="#/xhtml/08_Acknowledgement">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/10_Part01"><i>Gateway to the West</i></a></p>
<p class="toci"><a href="#/xhtml/11_Chapter01">Growing</a></p>
<p class="toci"><a href="#/xhtml/12_Chapter02">Newcomers in a Troubled Land</a></p>
<p class="toci"><a href="#/xhtml/13_Chapter03">The Cookies</a></p>
<p class="toci"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample">Commerce</span></p>
<p class="toci"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">Three Pokes of a Thistle</span></p>
<p class="toci"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample">Thank You in Arabic</span></p>
<p class="toc"><span href="#/xhtml/17_Part02" title="Link target outside of Sample"><i>World Gifts</i></span></p>
<p class="toci"><span href="#/xhtml/18_Chapter07" title="Link target outside of Sample">One Village</span></p>
<p class="toci"><span href="#/xhtml/19_Chapter08" title="Link target outside of Sample">Local Hospitality</span></p>
<p class="toci"><span href="#/xhtml/20_Chapter09" title="Link target outside of Sample">Grazing</span></p>
<p class="toci"><span href="#/xhtml/21_Chapter10" title="Link target outside of Sample">Roses for Lubbock</span></p>
<p class="toci"><span href="#/xhtml/22_Chapter11" title="Link target outside of Sample">Camel Like Only Camel</span></p>
<p class="toc"><span href="#/xhtml/23_Part03" title="Link target outside of Sample"><i>Lucky People</i></span></p>
<p class="toci"><span href="#/xhtml/24_Chapter12" title="Link target outside of Sample">The Rattle of Wheels toward the Rooms of the New Mothers</span></p>
<p class="toci"><span href="#/xhtml/25_Chapter13" title="Link target outside of Sample">Nineties</span></p>
<p class="toci"><span href="#/xhtml/26_Chapter14" title="Link target outside of Sample"><span epub:type="pagebreak" id="page_x" title="x">David Crockett’s Other Life</span></span></p>
<p class="toci"><span href="#/xhtml/27_Chapter15" title="Link target outside of Sample">Favorite Cleaners, San Antonio</span></p>
<p class="toci"><span href="#/xhtml/28_Chapter16" title="Link target outside of Sample">Enigma</span></p>
<p class="toci"><span href="#/xhtml/29_Chapter17" title="Link target outside of Sample">My Life with Medicine</span></p>
<p class="toci"><span href="#/xhtml/30_Chapter18" title="Link target outside of Sample">Speaking Arabic</span></p>
<p class="toci"><span href="#/xhtml/31_Chapter19" title="Link target outside of Sample">Maintenance</span></p>
<p class="toc"><span href="#/xhtml/32_Part04" title="Link target outside of Sample"><i>Troubled Land</i></span></p>
<p class="toci"><span href="#/xhtml/33_Chapter20" title="Link target outside of Sample">Tulips</span></p>
<p class="toci"><span href="#/xhtml/34_Chapter21" title="Link target outside of Sample">Pablo Tamayo</span></p>
<p class="toci"><span href="#/xhtml/35_Chapter22" title="Link target outside of Sample">The World and All Its Teeth</span></p>
<p class="toci"><span href="#/xhtml/36_Chapter23" title="Link target outside of Sample">Marie</span></p>
<p class="toci"><span href="#/xhtml/37_Chapter24" title="Link target outside of Sample">Keys</span></p>
<p class="toci"><span href="#/xhtml/38_Chapter25" title="Link target outside of Sample">Tomorrow We Smile</span></p>
<p class="toci"><span href="#/xhtml/39_Chapter26" title="Link target outside of Sample">Field Trip</span></p>
<p class="toci"><span href="#/xhtml/40_Chapter27" title="Link target outside of Sample">Neighborhood Quartet in a Minor Key</span></p>
<p class="toci"><span href="#/xhtml/41_Chapter28" title="Link target outside of Sample">Home Address</span></p>
<p class="toci"><span href="#/xhtml/42_Chapter29" title="Link target outside of Sample">Monumental</span></p>
<p class="toci"><span href="#/xhtml/43_Chapter30" title="Link target outside of Sample">Bread</span></p>
<p class="toci"><span href="#/xhtml/44_Chapter31" title="Link target outside of Sample">Broken Clock</span></p>
<p class="toc"><span href="#/xhtml/45_Part05" title="Link target outside of Sample"><i>Still the Sky</i></span></p>
<p class="toci"><span href="#/xhtml/46_Chapter32" title="Link target outside of Sample">Poetry</span></p>
<p class="toci"><span href="#/xhtml/47_Chapter33" title="Link target outside of Sample">Banned Poem</span></p>
<p class="toci"><span href="#/xhtml/48_Chapter34" title="Link target outside of Sample">Women of the West</span></p>
<p class="toci"><span href="#/xhtml/49_Chapter35" title="Link target outside of Sample">Used Cars on Oahu</span></p>
<p class="toci"><span href="#/xhtml/50_Chapter36" title="Link target outside of Sample">Mint Snowball</span></p>
<p class="toci"><span href="#/xhtml/51_Chapter37" title="Link target outside of Sample">White Coals</span></p>
<p class="toci"><span href="#/xhtml/52_Chapter38" title="Link target outside of Sample">Talk, Talk, Talk</span></p>
<p class="toci"><span href="#/xhtml/53_Chapter39" title="Link target outside of Sample">One Moment on Top of the Earth</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?1b5a5990